const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionAutre({ questionInfo , data , questionIndex , getNumberFiliereActif , getNumberCritereActif , sousCritereIndex}) {

    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */ 

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);
    const visible = isQuestionVisible(questionInfo, {
        dataFiltres: currentPeriod?.filtres,
        questionLookup
    });

    const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;

    try {
        questions[questionIndex].visible = visible;
    } catch {
    }

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */ 

    if (!visible) return null;

    return (
        <div className="question">
                {/*Affiche l'étiquette de la question*/}
                <label className="questionTitle">
                    {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
                </label>
                <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
                <div dangerouslySetInnerHTML={{ __html: questionInfo.value }}>
                
                </div>
        </div>
    );
}
